module.exports = __webpack_public_path__ + "static/media/Desktop_WhatIsCulture_22.5f804203.png";